import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";
import Authentication from "./modules/authentication.module";
import Counties from "./modules/counties.module";
import Agencies from "./modules/agencies.module";
import Regionals from "./modules/regionals.module";
import Forecast from "./modules/forecast.module";
import Error from "./modules/local/error.module";
import Filter from "./modules/filter.module";
import User from "./modules/user.module";
import Historical from "./modules/historical.module";
import WeatherAlert from "./modules/weatherAlert.module";

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  key: "vuex",
  storage: window.localStorage,
  modules: [
    "Authentication",
    "Counties",
    "Agencies",
    "Regionals",
    "Forecast",
    "Filter",
    "User",
    "Historical",
    "WeatherAlert",
  ],
});

export default new Vuex.Store({
  plugins: [vuexLocal.plugin],
  modules: {
    namespaced: true,
    Authentication,
    Counties,
    Agencies,
    Regionals,
    Forecast,
    Filter,
    Error,
    User,
    Historical,
    WeatherAlert,
  },
  state: {},
  getters: {},
  mutations: {},
  actions: {},
});
